import { createFileRoute } from "@tanstack/react-router";
import { loadLegacyContent, LegacyContent, legacyHead } from "@/lib/legacy-content";

export const Route = createFileRoute("/ent")({
  loader: () => loadLegacyContent("ent"),
  head: ({ loaderData }) =>
    loaderData ? legacyHead("/ent", loaderData) : { meta: [{ title: "ENT — Healic" }] },
  component: () => <LegacyContent payload={Route.useLoaderData()} />,
});
